import { Routes } from '@angular/router';

import { LOGIN_ROUTES } from './main/login-module/login.routes';
import { DASHBOARD_ROUTES } from './main/dashboard-module/dashboard.routes';
import { MESSAGES_ROUTES } from './main/messages-module/messages.routes';
import { REPORT_INCIDENT_ROUTES } from './main/report-incident/report-incident.routes';

export const routes: Routes = [
  ...LOGIN_ROUTES,
  ...DASHBOARD_ROUTES,
  ...MESSAGES_ROUTES,
  ...REPORT_INCIDENT_ROUTES,
];
